import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { NavigationService } from 'src/app/navigation/navigation.service';
 
@Component({
    selector: 'cv-cxone-play-icon-cell',
    templateUrl: './cxone-play-icon-cell.component.html',
    styleUrl: './cxone-play-icon-cell.component.scss'
})
export class CxonePlayIconCellComponent implements ICellRendererAngularComp {
 
    private segmentId: string;
    private evaluationId: string;
    private evaluationSubject: string;
 
    constructor(
        private navigationService: NavigationService
    ) { }
 
    agInit(params: ICellRendererParams): void {
        this.segmentId = params.data?.SEGMENT_ID;
        this.evaluationId = params.data?.EVALUATION_ID;
        this.evaluationSubject = params.data?.EVALUATION_SUBJECT_NAME;
    }
 
    refresh() {
        return false;
    }
 
    openPlayerWindow(event: MouseEvent): void {
        const windowOptions = "width=650,height=650";
 
        if (this.evaluationSubject === 'segment') {
            const mediaPlayerURL = this.getMediaPlayerURL(this.segmentId);
            const evaluationFormURL = this.getEvaluationFormPlayerURL(this.evaluationId);
 
            window.open(mediaPlayerURL, '', `${windowOptions},top=0,left=0`);
            window.open(evaluationFormURL, '', `${windowOptions},top=100,left=100`);
 
        } else if (this.evaluationSubject === 'employee') {
            const evaluationFormURL = this.getEvaluationFormPlayerURL(this.evaluationId);
            window.open(evaluationFormURL, '', `${windowOptions},top=0,left=0`);
        }
    }
 
    private getMediaPlayerURL(segmentId: string): string {
        const cxoneDomain = this.navigationService.cxoneTokenUrls;
        let mediaPlayerURL = cxoneDomain?.niceBaseUrl;
        mediaPlayerURL += `/player/#/cxone-player/segments/${segmentId}?mediaType=all`;
        return mediaPlayerURL;
    }
 
    private getEvaluationFormPlayerURL(evaluationId: string): string {
        const cxoneDomain = this.navigationService.cxoneTokenUrls;
        let evaluationFormURL = cxoneDomain?.niceBaseUrl;
        evaluationFormURL += `/qm/#/formExecutor?workFlowInstanceId=${evaluationId}&changeFormAllowed=ZmFsc2U%3D&scoringVisible=dHJ1ZQ%3D%3D&preferScoreOverRank=dHJ1ZQ%3D%3D`;
        return evaluationFormURL;
    }
}